import { clearSession, getLoginPath, publicApi, saveUserSession } from 'src/utils/auth';

export const fetchCheckToken = async (...args: any[]) => {};

export const login = async (paramData: any, loadingState: any, setErrorState: any, queryClient: any) => {
  loadingState({ active: '_active' });
  try {
    const { data } = await publicApi.post('/api/auth/user/login', paramData);
    if (String(data.status?.code) !== '200') throw new Error(data.status?.message || '로그인 실패');
    saveUserSession(data.data.result);
    queryClient.clear();
    window.location.href = '/main';
  } catch (error: any) {
    setErrorState({ active: '_active', data: {
      type: 'error', icon: 'ri-alert-line',
      mainTitle: error.response?.data?.status?.message || error.message || '로그인에 실패했습니다.',
      subTitle: '', code: String(error.response?.status || ''),
    } });
  } finally {
    loadingState({ active: '' });
  }
};

// 사번만으로는 인증할 수 없으므로 로그인 화면으로 이동합니다.
export const checkMember = async (...args: any[]) => {
  window.location.replace(getLoginPath());
};

export const logout = async () => {
  clearSession();
  window.location.href = getLoginPath();
};
